exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lp-menu-desc[data-v-20b5ba79],.lp-menu-title[data-v-20b5ba79]{padding:4px}.lp-menu-title[data-v-20b5ba79]{width:20%}.lp-menu-desc[data-v-20b5ba79]{width:80%}", ""]);

// exports
